
//api/myrequest/process-flow/get

export function getFlows() {
    return {
        "ok": true,
        "message": "Process flow fetched successfully",
        "data": {
            "_id": "696495fdb167d000695e88fd",
            "store": "SparkleTime KeepingDemo",
            "__v": 0,
            "activeProcessFlowId": "flow_1773882928260_8ipjy8fu8",
            "createdAt": "2026-01-12T06:34:37.167Z",
            "customStatuses": [
                {
                    "id": "pending",
                    "label": "Pending",
                    "color": "#E81F1F",
                    "description": "Request is awaiting review"
                },
                {
                    "id": "approve",
                    "label": "Approved",
                    "color": "#1F98E8",
                    "description": "Request has been approved"
                },
                {
                    "id": "pickup",
                    "label": "For Pickup",
                    "color": "#FFA500",
                    "description": "Ready for pickup"
                },
                {
                    "id": "completed",
                    "label": "Completed",
                    "color": "#4CAF50",
                    "description": "Request is complete"
                },
                {
                    "id": "rejected",
                    "label": "Rejected",
                    "color": "#F44336",
                    "description": "Request was rejected"
                }
            ],
            "processFlows": [
                {
                    "assignedFormUrls": [
                        "https://forms.sparkles.com.ph/form/698bf165cf6690c473f3e9c1"
                    ],
                    "isActive": true,
                    "createdByRole": "group",
                    "createdByUserId": "6864f5bbd993850087193f8f",
                    "finalStatusId": null,
                    "id": "flow_1773882928260_8ipjy8fu8",
                    "name": "test flow ",
                    "description": "must be chronologically",
                    "assignedStatuses": [
                        {
                            "assignedForms": [],
                            "filterMode": "all",
                            "isActive": true,
                            "statusId": "pending",
                            "order": 0
                        },
                        {
                            "assignedForms": [],
                            "filterMode": "all",
                            "isActive": true,
                            "statusId": "completed",
                            "order": 1
                        },
                        {
                            "assignedForms": [],
                            "filterMode": "all",
                            "isActive": true,
                            "statusId": "approve",
                            "order": 2
                        },
                        {
                            "assignedForms": [],
                            "filterMode": "all",
                            "isActive": true,
                            "statusId": "pickup",
                            "order": 3
                        },
                        {
                            "assignedForms": [],
                            "filterMode": "all",
                            "isActive": true,
                            "statusId": "rejected",
                            "order": 4
                        }
                    ],
                    "requiredSapexFields": [
                        {
                            "key": "email",
                            "type": "field-id-or-name-or-type",
                            "label": "email",
                            "isDefault": true
                        }
                    ],
                    "fieldIdMappings": {
                        "698bf165cf6690c473f3e9c1": {
                            "email": "89c57400-ed68-4ada-97ed-54c947e611da"
                        }
                    },
                    "formFieldsByFormId": {
                        "698bf165cf6690c473f3e9c1": [
                            {
                                "id": "89c57400-ed68-4ada-97ed-54c947e611da",
                                "name": "email",
                                "type": "respondent-email"
                            },
                            {
                                "id": "f0382f3d-dba2-483c-833c-c68624498256",
                                "name": "NAME",
                                "type": "text"
                            }
                        ]
                    }
                }
            ],
            "updatedAt": "2026-03-19T01:19:03.198Z",
            "statuses": [
                {
                    "value": "pending",
                    "label": "Pending",
                    "color": "#E81F1F",
                    "description": "Request is awaiting review",
                    "order": 0,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "completed",
                    "label": "Completed",
                    "color": "#4CAF50",
                    "description": "Request is complete",
                    "order": 1,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "approve",
                    "label": "Approved",
                    "color": "#1F98E8",
                    "description": "Request has been approved",
                    "order": 2,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "pickup",
                    "label": "For Pickup",
                    "color": "#FFA500",
                    "description": "Ready for pickup",
                    "order": 3,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "rejected",
                    "label": "Rejected",
                    "color": "#F44336",
                    "description": "Request was rejected",
                    "order": 4,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                }
            ]
        }
    }
}

//v2/myrequest/process/flow_1773882928260_8ipjy8fu8/responses/bulk
//v2/myrequest/employee/process/flow_1768464352372_8ve2n16lz/responses/bulk
export function getRequestsForFlow() {
    return {
        "data": {
            "counts": {
                "pending": 1
            },
            "processFlow": {
                "id": "flow_1773882928260_8ipjy8fu8",
                "name": "test flow "
            },
            "statuses": [
                {
                    "value": "pending",
                    "label": "Pending",
                    "color": "#E81F1F",
                    "description": "Request is awaiting review",
                    "order": 0,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "completed",
                    "label": "Completed",
                    "color": "#4CAF50",
                    "description": "Request is complete",
                    "order": 1,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "approve",
                    "label": "Approved",
                    "color": "#1F98E8",
                    "description": "Request has been approved",
                    "order": 2,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "pickup",
                    "label": "For Pickup",
                    "color": "#FFA500",
                    "description": "Ready for pickup",
                    "order": 3,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                },
                {
                    "value": "rejected",
                    "label": "Rejected",
                    "color": "#F44336",
                    "description": "Request was rejected",
                    "order": 4,
                    "assignedForms": [],
                    "filterMode": "all",
                    "isActive": true
                }
            ],
            "items": [
                {
                    "formUrl": "https://forms.sparkles.com.ph/form/698bf165cf6690c473f3e9c1",
                    "sapexFormId": "698bf165cf6690c473f3e9c1",
                    "sapexResponseId": "69f1933fe42dd13ea49c03fa",
                    "createdAt": "2026-04-29T05:12:31.286Z",
                    "answers": {
                        "89c57400-ed68-4ada-97ed-54c947e611da": "cosimshiena@gmail.com",
                        "f0382f3d-dba2-483c-833c-c68624498256": "setser",
                        "date": "Wed Apr 29 2026 13:12:31 GMT+0800 (Philippine Standard Time)"
                    },
                    "fields": [
                        {
                            "id": "89c57400-ed68-4ada-97ed-54c947e611da",
                            "name": "email",
                            "type": "respondent-email"
                        },
                        {
                            "id": "f0382f3d-dba2-483c-833c-c68624498256",
                            "name": "NAME",
                            "type": "text"
                        }
                    ],
                    "statusRecord": {
                        "id": "69f1933f4fdcea00572136c8",
                        "status": "pending",
                        "remarks": "",
                        "createdBy": "cosimshiena@gmail.com",
                        "createdDate": "2026-04-29T05:12:31.286Z",
                        "store": "SparkleTime KeepingDemo",
                        "employeeConfirmedAt": null
                    }
                }
            ],
            "count": 1
        },
        "error": null,
        "meta": {
            "store": "SparkleTime KeepingDemo",
            "processFlowId": "flow_1773882928260_8ipjy8fu8",
            "email": "cosimshiena@gmail.com",
            "status": "pending",
            "page": 0,
            "rowsPerPage": 10
        }
    }
}

//v2/myrequeststatus/69f1933f4fdcea00572136c8/logs
export function getRequestLogs() {
    return {
        "data": {
            "id": "69f1933f4fdcea00572136c8",
            "status": "pending",
            "statusHistory": []
        },
        "error": null,
        "meta": null
    }
}
